class AccidentType {
  constructor() { }
  id = 0;
  accidentNumber = 0;
  regNumber = "";
  oldRegNumber = "";
  insuranceType = 1;
  policyType = null;
  policyId = null;
  policyNumber = null;
  personType = null;
  identNumber = "";
  insuredName = "";
  brandId = null;
  modelId = null;
  brandName = "";
  modelName = "";
  brandModel = "";
  customBrandModel = "";
  regionId = null;
  regionName = "";
  startDate = null;
  endDate = null;
  volStartDate = null;
  volEndDate = null;
  insurancePeriod = "";
  voluntaryPeriod = "";;
  callPerson = "";
  callPhone = "";
  otherPhone = "";
  phone = "";
  driver = "";
  driverPhone = "";
  callDate = null;
  accidentDate = null;
  callNotes = "";
  accidentCommUid = null;
  productionYear = null;
  modelTypeId = null;
  modelTypeName = null;
  place = "";
  descr = "";
  policyStatus = "";
  injured = null;
  chainAccident = null;
  insuranceCompId = null;
  orgName = "";
  vehicleCount = 1;
  noInfoOs = 0;
  isProperty = null;
  isAnimal = null;
  newRegNumber = "";
  driverNoInfo = false;
  driverDescr = "";
  numberOfSeats = null;
  branchName = null;
  isWrongCall = 0;
  approachedOffice = 0;
  address = "";
    skipAccidentComm = 1;
  requestCorrelationId = crypto.randomUUID();
}


class PolicyStatusType {
  constructor() { }
  id = 0;
  accidentId = null;
  voluntaryPolicyId = null;
  compulsoryPolicyId = null;
  regNumber = null;
  voluntaryStatus = null;
  compulsoryStatus = null;
  timer = null;
}


class AccidentCommType {
  constructor() { }
  needDeparture = 1;
  departureNote = null;
  leaveDate = "";
  regionId = null;
  accidentCommUid = null;
  vehicleCount = 2;
  commPlace = "";
  zbt = null;
  commInjured = null;
  commChainAccident = null;
  victim = null;
  incidentCauseId = null;
  commAccidentDate = "";
  observationPlace = null;
  checkReportStatus = 0;
}

class ParticipantType {
  constructor() { }
  id = 0;
  insuranceType = 1;
  accidentId = 0;
  regNumber = "";
  oldRegNumber = "";
  policyId = "";
  serviceCenterId = null;
  notSendService = null;
  serviceCenterDate = null;
  policyNumber = "";
  startDate = null;
  endDate = null;
  insurancePeriod = "";
  phone = "";
  personType = null;
  identNumber = "";
  otherIdentNumber = "";
  personName = "";
  brandId = null;
  modelId = null;
  brandName = "";
  modelName = "";
  brandModel = null;
  modelTypeId = null;
  modelTypeName = null;
  customBrandModel = null;
  vin = null;
  productionYear = null;
  damageSum = null;
  mileage = 0;
  damageType = 1;
  participantType = 2;
  partPersonName = "";
  partPersonPhone = "";
  otherDriverPhone = "";
  evacuationStatus = 0;
  otherProperty = "";
  otherPropertyNumber = "";
  otherPropertyName = "";
  descr = "";
  finishDate = null;
  finishNote = null;
  finishReason = null;
  fraud = null;
  fraudNote = null;
  officialAgencyId = null;
  insuranceCompId = null;
  otherAgency = null;
  driverLicense = null;
  drivingYears = null;
  vinCheck = null;
  purposeOfUse = null;
  subragation = null;
  noInfo = null;
  noInfoCompany = null;
  orgName = "";
  otherPurposeOfUse = "";
  accidentStage = 1;
  insType = "";
  insTypeName = "";
  insuredSum = "";
  cost = null;
  sumInsuredPerson = null;
  seatCount = null;
  medicalExpense = null;
  sumInsuredPersonTpl = null;
  sumInsuredAccident = null;
  propertyDamageSum = null;
  medicalExpenseTotal = null;
  deductible = null;
  unconditionalDeductible = null;
  policyIndex = null;
}

class ClaimType {
  constructor() { }
  id = 0;
  accidentId = 0;
  insuranceParticipantId = null;
  osParticipantId = null;
}

class FileType {
  id = 0;
  filename = "";
  sourcetype = 0;
  sourceId = "";
  ///sourcedetId = "";
}
class ClaimDocType {
  id = 0;
  claimId = 0;
  claimDocTmplId = null;
}

class TechExpertType {
  id = 0;
  claimId = 0;
}

class ClaimActType {
  id = 0;
  claimId = 0;
}

class RepairStageType {
  constructor() { }
  id = null;
  claimId = 0;
  stageId = null;
  price = null;
  notes = "";
}

class SparePartType {
  constructor() { }
  id = null;
  claimId = 0;
  count = 1;
  stageId = null;
  partName = "";
  price = null;
}
class ServiceCenterType {
  constructor() { }
  id = 0;
  name = "";
  bankId = null;
  accountNumber = "";
  serviceTin = "";
  startDate = null
  endDate = null;
  contractPerson = "";
  contractPhone = "";
  contractNumber = "";
  email = "";
  notes = "";
  active = 1;
}

class ParticipantReport {
  constructor() { }
  id = 0;
  accidentId = 0;
  participantId = null;
  frontDoorRight = null;
  frontDoorLeft = null;
  frontDoorWindowRight = null;
  frontDoorWindowLeft = null;
  frontMirrorRight = null;
  frontMirrorLeft = null;
  frontWheelRight = null;
  frontWheelLeft = null;
  frontHeadlightRight = null;
  frontHeadlightLeft = null;
  frontTurnSignalRight = null;
  frontTurnSignalLeft = null;
  frontFenderRight = null;
  frontFenderLeft = null;
  frontDiskRight = null;
  frontDiskLeft = null;
  frontUnderCarriageRight = null;
  frontUnderCarriageLeft = null;
  frontFootboardRight = null;
  frontFootboardLeft = null;
  frontPillarRight = null;
  frontPillarLeft = null;
  frontFogLightRight = null;
  frontFogLightLeft = null;
  frontWheelWellRight = null;
  frontWheelWellLeft = null;
  frontDescr = null;
  visor = null;
  windshield = null;
  frontBumper = null;
  hood = null;
  enginePart = null;
  backDoorRight = null;
  backDoorLeft = null;
  backDoorWindowRight = null;
  backDoorWindowLeft = null;
  backFootboardRight = null;
  backFootboardLeft = null;
  backDiskRight = null;
  backDiskLeft = null;
  backTailLamp = null;
  backTailLightRight = null;
  backTailLightLeft = null;
  backLightReflectorRight = null;
  backLightReflectorRight = null;
  backUnderCarriageRight = null;
  backUnderCarriageLeft = null;
  backPillarRight = null;
  backPillarLeft = null;
  backWheelRight = null;
  backWheelLeft = null;
  backWheelWellRight = null;
  backWheelWellLeft = null;
  backBumper = null;
  backDescr = null;
  rearWinscreen = null;
  muffler = null;
  spoiler = null;
  dashboard = null;
  tailgate = null;
  roof = null;
  sunRoof = null;
  pillar = null;
  steering = null;
  airbagRight = null;
  airbagLeft = null;
  centerRightPillar = null;
  centerLeftPillar = null;
}


class AssessmentType {
  constructor() { }
  id = 0;
  claimId = null;
  amountFrom = null;
  amountTo = null;
  agreedAmount = null;
  damageAmount = null;
  status = null;
  note = null;
  repairConfirmed = null;
  repairAmount = null;

}


class CommUnsign {
  constructor() { }
  id = 0;
  accidentId = null;
  commId = null;
  reason = null;
  commUid = null;
}

class OppositeSide {
  constructor() { }
  id = null;
  accidentId = 0;
  customBrandModel = null;
  orgName = null;
  regNumber = "";
  insuranceType = null;
  startDate = null;
  endDate = null;
  volStartDate = null;
  volEndDate = null;
}


export {
  AccidentType, AccidentCommType, FileType, ParticipantType, ClaimType, ClaimDocType, TechExpertType,
  ClaimActType, RepairStageType, SparePartType, ServiceCenterType, PolicyStatusType, ParticipantReport,
  AssessmentType, CommUnsign, OppositeSide
};
